export function setHelp(help) {
    return {
        type: 'HELP_SET',
        payload: help,
    };
}
